import { FC } from 'react';
import { ViewNoteSection } from './ViewNoteSection';
import { ImageIcon } from '../../theme/Icons';
import { AttachmentList } from '../generic-notes/attachments/AttachmentList';
import { createUseStyles } from 'react-jss';
import { isPlatform } from '@ionic/react';

const useStyles = createUseStyles({
    attachmentArea: isPlatform('desktop') ? {
        minHeight: 170,
        '& hr': {
            width: '100%',
            marginBlockStart: -6
        },
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
    } : {
        minHeight: 70,
        '& hr': {
            marginBlockStart: -6
        }
    }
});

export const Attachments: FC<{ note: any; editHandler: () => void; }> = ({ note, editHandler }) => {
    const classes = useStyles();

    return (
        <ViewNoteSection title="Attachments" Icon={ImageIcon}>
            {note.attachments.length > 0 ? (
                <div className={classes.attachmentArea}>
                    <AttachmentList
                        note={note}
                        attachments={note.attachments}
                        marginBottom={12}
                    />
                </div>
            ) : (
                <div>
                    <div style={{display: 'inline-block', cursor: 'pointer', color: 'var(--ion-color-primary)'}} onClick={editHandler}>Edit</div> to add relevant files, photos and more.
                </div>
            )}
        </ViewNoteSection>
    );
};
